import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-money',
  templateUrl: './money.component.html',
  styleUrls: ['./money.component.scss']
})
export class MoneyComponent {
  @Input() price: number = 0.00
  @Input() currency: string = 'USD'
  @Input() position: string = 'end'
}
